import { Box, Button, useMediaQuery } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useRouter } from "next/router";
import { localStorageWrapper } from "@/utils/storage";
import { useTheme } from "@emotion/react";
import { useQuery } from "@apollo/client";
import { PROFILE } from "@/graphql/queries/profile";

export default function Impersonation() {
    const router = useRouter();

    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const theme = useTheme();
    const mobileViewMatches = useMediaQuery(theme.breakpoints.down("sm"));

    const getBackUrl = () => {
        const baseUrl = process.env.NEXT_PUBLIC_IMPERSONATE_BACK_URL;
        if (profile?.phoneNumber) {
            return `${baseUrl}?q=${profile?.phoneNumber}`;
        }
        return baseUrl;
    };

    const handleClickBack = () => {
        localStorageWrapper.clearAuthValues();
        router.push(getBackUrl());
    };

    return (
        <Box
            sx={{
                position: "relative",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "30px",
                backgroundColor: "#ef5350",
                color: "white",
                padding: { xs: "0 10px", lg: "0 5%" },
                zIndex: 99999999,
            }}
        >
            <div className="text-[0.8rem] font-bold whitespace-nowrap">
                در حال مشاهده صفحه کاربر می باشید
            </div>
            <Button
                variant="text"
                onClick={handleClickBack}
                sx={{
                    color: "white",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                }}
                startIcon={
                    <ArrowForwardIosIcon
                        sx={{ "&.MuiSvgIcon-root": { fontSize: "0.8rem" } }}
                    />
                }
            >
                {mobileViewMatches && "بازگشت"}
                {!mobileViewMatches && "بازگشت به پنل ادمین"}
            </Button>
        </Box>
    );
}
